export default {
  1: `<div class="articleLR-one">
  <div class="article-inner" :style="articleInnerStyl">
    <div
      class="article-box"
      :style="articleBoxStyl"
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      @mouseover="overArticleItem(item)"
    >
        <div class="img" :style="imageStyl" v-if="publishContent.includeItemsImageOrVideo">
        <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]"/>
        <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]"/>
        <div class="video-overly" v-if="item[isFileType] == 2 || item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          @click="clickSwiperItem(item)" alt="">
        </div>
      </div>
      <div class="article">
        <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle">
          {{showContentType == '2'? item.articleTitle: item.titleName}}
        </div>
        <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes">
          {{showContentType == '1'?item.titleDes : item.articleAbstract}}
        </div>
        <p :style="publishStyle" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime}}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyl.pagingStatus"></dyPaging>
</div>`,
  2: `<div class="articleLR-two" >
  <div class="article-inner" :style="articleInnerStyl">
    <div   
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box" 
      :style="articleBoxStyl" 
      @mouseover="overArticleItem(item)"
    >
          <div class="img" :style="imageStyl" v-if="publishContent.includeItemsImageOrVideo">
        <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]" />
        <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]" />
        <div class="video-overly" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          @click="clickSwiperItem(item)" alt="">
        </div>
      </div>
      <div class="article">
        <div
          class="main-title"
          :style="mainTitle"
          v-if="publishContent.includeItemsTitle"
        >
          {{showContentType == '2'? item.articleTitle: item.titleName}}
        </div>
        <div
          class="description"
          :style="descriptionTitle"
          v-if="publishContent.includeItemsDes"
        >
          {{showContentType == '1'?item.titleDes : item.articleAbstract}}
        </div>
        <p :style="publishStyle" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyl.pagingStatus"/>
</div>`,
  3: `<div class="article-LR">
  <div class="article-inner" :style="articleInnerStyl">
    <div
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
          <div class="img" :style="imageStyl" v-if="publishContent.includeItemsImageOrVideo">
        <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]"/>
        <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]"/>
        <div class="video-overly" v-if="item[isFileType] == 2 || item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          alt="">
        </div>
      </div>
      <div class="article">
        <div
          class="main-title"
          :style="mainTitle"
          v-if="publishContent.includeItemsTitle"
        >
          {{showContentType == '2'? item.articleTitle: item.titleName}}
        </div>
        <div
          class="description"
          :style="descriptionTitle"
          v-if="publishContent.includeItemsDes"
        >
          {{showContentType == '1'?item.titleDes : item.articleAbstract}}
        </div>
        <p :style="publishStyle" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px">  {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyl.pagingStatus"></dyPaging>
</div>`,
  4: `<div class="articleTB-two">
  <div class="article-inner" v-if="publishContent.showRows==2" :style="articleInnerStyl">
    <div 
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
      <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
        <div class="img" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl"> 
      </div>
       <div class="video-overly" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          @click="skipLinks(item)">
        </div>
      </div>
      <div class="article" v-if="
      (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
        <div
          class="main-title"
          :style="mainTitle"
          v-if="publishContent.includeItemsTitle&&item[showMainTile]"
        >
          {{item[showMainTile]}}
        </div>
        <div
          class="description"
          :style="descriptionTitle"
         v-if="publishContent.includeItemsDes&&item[showMainDesc]"
        >
          {{item[showMainDesc]}}
        </div>
        <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime | formatTime}}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="swiper-wrap" v-if="publishContent.showRows==1" :style="videoOverlyStyl">
    <div :class="\`swiper-container swiper-container\${receiveProps.blockInstanceId}\`">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in articleDataList"
          :key="index"
          :style="swiperBoxStyl"
        >
            <div class="inner-swiper" @mouseover="overArticleItem(item)">
            <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
              <div class="image-swiper" @click="skipLinks(item)" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl">
              <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]"/>
              
            </div>
            <div class="video-overly" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          @click="skipLinks(item)">
        </div>
            </div>
            <div class="article" v-if="
            (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
              <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
                {{item[showMainTile]}}
              </div>
              <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes&&item[showMainDesc]">
                {{item[showMainDesc]}}
              </div>
              <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
                <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
                <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Arrows -->
    <div class="button-box">
       <div :class="\`swiper-button-next\${receiveProps.blockInstanceId}\`" :style="nextBtnStyl"><img src="../../asset/images/right-btn.png" alt=""></div>
      <div :class="\`swiper-button-prev\${receiveProps.blockInstanceId}\`" :style="prevBtnStyl"><img src="../../asset/images/left-btn.png" alt=""></div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyle.pagingStatus" />
</div>`,
  5: `<div class="article-thr">
  <div class="article-inner" v-if="publishContent.showRows==2" :style="articleInnerStyl">
    <div
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
         <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
            <div class="img" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl">
      </div>
      <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
           alt="">
        </div>
         </div>
      <div class="article" v-if="
      (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
        <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
          {{item[showMainTile]}}
        </div>
        <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes&&item[showMainDesc]">
          {{item[showMainDesc]}}
        </div>
        <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="swiper-wrap" v-if="publishContent.showRows==1" :style="videoOverlyStyl">
    <div :class="\`swiper-container swiper-container\${receiveProps.blockInstanceId}\`">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in articleDataList"
          :key="index"
          :style="swiperBoxStyl"
        >
            <div class="inner-swiper" @mouseover="overArticleItem(item)">
            <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
              <div class="image-swiper" @click="skipLinks(item)" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl">
            </div>
            <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          >
        </div>
            </div>
            <div class="article" v-if="
            (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
              <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
                {{item[showMainTile]}}
              </div>
              <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes">
                {{item[showMainDesc]}}
              </div>
              <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
                <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime}}</span>
                <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Arrows -->
    <div class="button-box">
      <div :class="\`swiper-button-next\${receiveProps.blockInstanceId}\`" :style="nextBtnStyl"><img src="../../asset/images/right-btn.png" alt=""></div>
      <div :class="\`swiper-button-prev\${receiveProps.blockInstanceId}\`" :style="prevBtnStyl"><img src="../../asset/images/left-btn.png" alt=""></div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyle.pagingStatus" />
</div>`,
  6: `<div class="articleTB-four">
  <div class="article-inner" v-if="publishContent.showRows==2" :style="articleInnerStyl">
    <div
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
        <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
          <div class="img" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl"
        >
      </div>
      <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          >
        </div>
        </div>
      <div class="article" v-if="
      (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
        <div class="main-title" :style="mainTitle"
        v-if="publishContent.includeItemsTitle&&item[showMainTile]">
          {{item[showMainTile]}}
        </div>
        <div class="description" :style="descriptionTitle"
        v-if="publishContent.includeItemsDes&&item[showMainDesc]">
          {{item[showMainDesc]}}
        </div>
        <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime | formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="swiper-wrap" v-if="publishContent.showRows==1" :style="videoOverlyStyl">
    <div :class="\`swiper-container swiper-container\${receiveProps.blockInstanceId}\`">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in articleDataList"
          :key="index"
          :style="swiperBoxStyl"
          @mouseover="overArticleItem(item)"
        >
          <div class="inner-swiper" @mouseover="overArticleItem(item)">
            <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
              <div class="image-swiper" @click="skipLinks(item)" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl">
            </div>
            <div class="video-overly" :style="videoOverlyStyl" @mouseover="overArticleItem(item)" @click="skipLinks(item)" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          >
        </div>
            </div>
            <div class="article" v-if="
            (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
              <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
                {{item[showMainTile]}}
              </div>
              <div class="description" :style="descriptionTitle"
              v-if="publishContent.includeItemsDes&&item[showMainDesc]">
                {{item[showMainDesc]}}
              </div>
              <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
                <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime | formatTime}}</span>
                <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Arrows -->
    <div class="button-box">
       <div :class="\`swiper-button-next\${receiveProps.blockInstanceId}\`" :style="nextBtnStyl"><img src="../../asset/images/right-btn.png" alt=""></div>
      <div :class="\`swiper-button-prev\${receiveProps.blockInstanceId}\`" :style="prevBtnStyl"><img src="../../asset/images/left-btn.png" alt=""></div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyle.pagingStatus" />
</div>`,
  7: `<div class="article-five">
  <div class="article-inner" v-if="publishContent.showRows==2" :style="articleInnerStyl">
    <div
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
          <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
            <div class="img" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl"
          >
          </div>
      <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] == 2 || item.selectType==2">
          <img src="../../asset/images/video-btn.png">
        </div>
          </div>
      <div class="article" v-if="
      (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
        <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
          {{item[showMainTile]}}
        </div>
        <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes&&item[showMainDesc]">
          {{item[showMainDesc]}}
        </div>
        <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="swiper-wrap" v-if="publishContent.showRows==1" :style="videoOverlyStyl">
    <div :class="\`swiper-container swiper-container\${receiveProps.blockInstanceId}\`">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in articleDataList"
          :key="index"
          :style="swiperBoxStyl"
        >
            <div class="inner-swiper" @mouseover="overArticleItem(item)"
            >
            <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
              <div class="image-swiper" @click="skipLinks(item)" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl" >
              <!-- <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]"/> -->
              <!-- <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]"/> -->
              
            </div>
            <div class="video-overly" @click="skipLinks(item)" v-if="item[isFileType] || item.selectType==2 ">
          <img src="../../asset/images/video-btn.png">
        </div>
            </div>
            <div class="article" v-if="
            (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
              <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
                {{item[showMainTile]}}
              </div>
              <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes&&item[showMainDesc]">
                {{item[showMainDesc]}}
              </div>
              <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
                <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
                <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Arrows -->
    <div class="button-box">
      <div :class="\`swiper-button-next\${receiveProps.blockInstanceId}\`" :style="nextBtnStyl">
        <img src="../../asset/images/right-btn.png" alt=""></div>
      <div :class="\`swiper-button-prev\${receiveProps.blockInstanceId}\`" :style="prevBtnStyl">
        <img src="../../asset/images/left-btn.png" alt=""></div>
    </div>
  </div>
   <dyPaging :paging="paging" v-if="publishStyle.pagingStatus"/>
</div>`,
  8: `<div class="articleTB-six" >
  <div class="article-inner" v-if="publishContent.showRows==2" :style="articleInnerStyl">
    <div
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
      <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
        <div class="img" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl" >
      </div>
      <div @click="skipLinks(item)" class="video-overly" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png" alt="">
        </div>
      </div>
      <div class="article"
      v-if="(publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
        <div class="main-title" 
        :style="mainTitle" 
        v-if="publishContent.includeItemsTitle&&item[showMainTile]">
          {{item[showMainTile]}}
        </div>
        <div class="description" :style="descriptionTitle"
        v-if="publishContent.includeItemsDes&&item[showMainDesc]">
          {{item[showMainDesc]}}
        </div>
        <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime | formatTime}}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px">{{item.readNum}}</span> 
        </p>
      </div>
    </div>
  </div>
  <div class="swiper-wrap" v-if="publishContent.showRows==1" :style="videoOverlyStyl">
    <div :class="\`swiper-container swiper-container\${receiveProps.blockInstanceId}\`">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in articleDataList"
          :key="index"
          :style="swiperBoxStyl"
          @mouseover="overArticleItem(item)"
        >
            <div class="inner-swiper">
            <div style="position: relative" v-if="publishContent.includeItemsImageOrVideo">
              <div class="image-swiper" @click="skipLinks(item)" :class="\`img\${receiveProps.blockInstanceId}\${index}\`" :style="imageStyl">
            </div>
            <div @click="skipLinks(item)" class="video-overly" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
           alt="">
        </div>
            </div>
            <div class="article" v-if="
            (publishContent.includeItemsTitle&&item[showMainTile])||(publishContent.includeItemsDes&&item[showMainDesc])">
              <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle&&item[showMainTile]">
                {{item[showMainTile]}}
              </div>
              <div class="description" :style="descriptionTitle"
              v-if="publishContent.includeItemsDes&&item[showMainDesc]">
                {{item[showMainDesc]}}
              </div>
              <p :style="publishStyl" v-if="publishContent.showContentType == 2" class="publish-num">
                <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
                <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Arrows -->
    <div class="button-box">
      <div :class="\`swiper-button-next\${receiveProps.blockInstanceId}\`" :style="nextBtnStyl"><img src="../../asset/images/right-btn.png" alt=""></div>
      <div :class="\`swiper-button-prev\${receiveProps.blockInstanceId}\`" :style="prevBtnStyl"><img src="../../asset/images/left-btn.png" alt=""></div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyle.pagingStatus" />
</div>`,
  9: `<div :style="adaptContainStyl">
  <div class="adaptive-one" v-for="(item, index) in articleDataList" :key="index" @click="skipLinks(item)" :style="articleContainStyl" @mouseover="overArticleItem(item)">
      <div class="title-box" :style="mainTitle">{{showContentType == '2'? item.articleTitle: item.titleName}}</div>
      <div class="publish">
          <!-- <div class="read-num">{{'我是大眼睛'}}</div> -->
          <div class="read-num" v-if="publishContent.showReadFlag&&item.readNum">
              <img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px">
              {{ item.readNum}}
              </div>
          <div class="time-box" v-if="publishContent.showPublishFlag&&item.publishTime">{{ item.publishTime | formatTime}}</div>
      </div>
  </div>
</div>`,
  10: `<div class="articleLR-one">
  <div class="article-inner" :style="articleInnerStyl">
    <div
      class="article-box"
      :style="articleBoxStyl"
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      @mouseover="overArticleItem(item)"
    >
        <div class="img" :style="imageStyl" v-if="publishContent.includeItemsImageOrVideo">
            <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]"/>
            <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]"/>
            <div class="video-overly" v-if="item[isFileType] == 2 || item.selectType==2">
            <img src="../../asset/images/video-btn.png"
              @click="clickSwiperItem(item)" alt="">
        </div>
      </div>
      <div class="article">
        <div class="main-title" :style="mainTitle" v-if="publishContent.includeItemsTitle">
          {{showContentType == '2'? item.articleTitle: item.titleName}}
        </div>
        <div class="description" :style="descriptionTitle" v-if="publishContent.includeItemsDes">
          {{showContentType == '1'?item.titleDes : item.articleAbstract}}
        </div>
        <p :style="publishStyle" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime}}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyl.pagingStatus"></dyPaging>
</div>`,
  11: `<div class="articleLR-two" >
  <div class="article-inner" :style="articleInnerStyl">
    <div   
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box" 
      :style="articleBoxStyl" 
      @mouseover="overArticleItem(item)"
    >
      
      <div class="article">
        <div
          class="main-title"
          :style="mainTitle"
          v-if="publishContent.includeItemsTitle"
        >
          {{showContentType == '2'? item.articleTitle: item.titleName}}
        </div>
        <div
          class="description"
          :style="descriptionTitle"
          v-if="publishContent.includeItemsDes"
        >
          {{showContentType == '1'?item.titleDes : item.articleAbstract}}
        </div>
        <p :style="publishStyle" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px"> {{item.readNum}}</span>
        </p>
      </div>
      <div class="img" :style="imageStyl" v-if="publishContent.includeItemsImageOrVideo">
        <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]" />
        <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]" />
        <div class="video-overly" v-if="item[isFileType] == 2|| item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          @click="clickSwiperItem(item)" alt="">
      </div>
      </div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyl.pagingStatus"/>
</div>`,
  12: `<div class="article-RL">
  <div class="article-inner" :style="articleInnerStyl">
    <div
      v-for="(item, index) in articleDataList"
      :key="index"
      @click="skipLinks(item)"
      class="article-box"
      :style="articleBoxStyl"
      @mouseover="overArticleItem(item)"
    >
      <div class="article">
        <div
          class="main-title"
          :style="mainTitle"
          v-if="publishContent.includeItemsTitle"
        >
          {{showContentType == '2'? item.articleTitle: item.titleName}}
        </div>
        <div
          class="description"
          :style="descriptionTitle"
          v-if="publishContent.includeItemsDes"
        >
          {{showContentType == '1'?item.titleDes : item.articleAbstract}}
        </div>
        <p :style="publishStyle" v-if="publishContent.showContentType == 2" class="publish-num">
          <span class="publish-time" v-if="publishContent.showPublishFlag">{{ item.publishTime |formatTime }}</span>
          <span class="obser-num" v-if="publishContent.showReadFlag"><img src="../../asset/images/obser-num-img.png" style="width: 14px;height: 14px">  {{item.readNum}}</span>
        </p>
      </div>
      <div class="img" :style="imageStyl" v-if="publishContent.includeItemsImageOrVideo">
          <img :src="item[showImgUrl]" alt="" v-if="item[showImgUrl]"/>
          <img src="../../asset/images/default-img.jpg" alt="" v-if="!item[showImgUrl]"/>
          <div class="video-overly" v-if="item[isFileType] == 2 || item.selectType==2">
          <img src="../../asset/images/video-btn.png"
          alt="">
        </div>
      </div>
    </div>
  </div>
  <dyPaging :paging="paging" v-if="publishStyl.pagingStatus"></dyPaging>
</div>`
}